const getDate = () => {
    const today = new Date()
    today.setDate(today.getDate() + 30)
    return `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`
}

const accounts = [
    {
        "account_id": "c49a5169-bf6e-4776-8d86-00badf3f482e",
        "name": "Current Account",
        "currency_code": "SAR",
        "type": "CURRENT",
        "iban": "SA020090004001079346500",
        "bank_identifier": "SNB_SAU",
        "credit": null
    }, {
        "account_id": "31e9387c-2815-4a70-98b4-5bf140d1136e",
        "name": "Future Account",
        "currency_code": "SAR",
        "type": "SAVINGS",
        "iban": "SA020090004001092837391",
        "bank_identifier": "ALRAJHI_SAU",
        "credit": null
    }, {
        "account_id": "a33d9e07-5d24-4491-a29b-07915b0f066f",
        "name": "Wazen",
        "currency_code": "SAR",
        "type": "SAVINGS",
        "iban": "SA020090004009172547282",
        "bank_identifier": "RIYAD_SAU",
        "credit": null
    }, {
        "account_id": "031c226f-5510-4d17-9bc3-3275b51f5b44",
        "name": "Platinum Credit Card",
        "currency_code": "SAR",
        "type": "CREDIT",
        "iban": null,
        "bank_identifier": "ALRAJHI_SAU",
        "credit": {
            "card_number_last_four": 1232,
            "limit": -400000,
            "next_payment_due_date": getDate(),
            "next_payment_due_amount": 1773.21,
        }
    }
]

export const ksaAccountsAndBalances = {
    accounts: [
        {
            "account_id": "c49a5169-bf6e-4776-8d86-00badf3f482e",
            "name": "Current Account",
            "currency_code": "SAR",
            "type": "CURRENT",
            "iban": "SA020090004001079346500",
            "bank_identifier": "SNB_SAU",
            "credit": null
        }, {
            "account_id": "31e9387c-2815-4a70-98b4-5bf140d1136e",
            "name": "Future Account",
            "currency_code": "SAR",
            "type": "SAVINGS",
            "iban": "SA020090004001092837391",
            "bank_identifier": "ALRAJHI_SAU",
            "credit": null
        }, {
            "account_id": "a33d9e07-5d24-4491-a29b-07915b0f066f",
            "name": "Wazen",
            "currency_code": "SAR",
            "type": "SAVINGS",
            "iban": "SA020090004009172547282",
            "bank_identifier": "RIYAD_SAU",
            "credit": null
        }, {
            "account_id": "031c226f-5510-4d17-9bc3-3275b51f5b44",
            "name": "Platinum Credit Card",
            "currency_code": "SAR",
            "type": "CREDIT",
            "iban": null,
            "bank_identifier": "ALRAJHI_SAU",
            "credit": {
                "card_number_last_four": 1232,
                "limit": -400000,
                "next_payment_due_date": getDate(),
                "next_payment_due_amount": 1773.21,
            }
        }
    ],
    balances: [
        {
            "account_id": "c49a5169-bf6e-4776-8d86-00badf3f482e",
            "balance": 15035.85,
            "currency_code": "SAR",
            "account_name": "Current Account",
            "account_type": "CURRENT"
        }, {
            "account_id": "31e9387c-2815-4a70-98b4-5bf140d1136e",
            "balance": 50392.85,
            "currency_code": "SAR",
            "account_name": "Future Account",
            "account_type": "SAVINGS"
        }, {
            "account_id": "a33d9e07-5d24-4491-a29b-07915b0f066f",
            "balance": 16890.23,
            "currency_code": "SAR",
            "account_name": "Wazen",
            "account_type": "SAVINGS"
        }, {
            "account_id": "031c226f-5510-4d17-9bc3-3275b51f5b44",
            "balance": -193584.67,
            "currency_code": "SAR",
            "account_name": "Platinum Credit Card",
            "account_type": "CREDIT"
        }
    ]
}

export default accounts